import React, { useEffect } from 'react'

function Disclaimer() {

    useEffect(() => {
        alert("Le site que vous vous apprêtez à visiter n'est pas le site de Grand Spirit, mais un site réalisé pour une session d'examen.")
    }) 
    

  return (
    <></>
  )
}

export default Disclaimer